<template>
    <div class="my-4" :class="{'tracking-background': !withInput && !clientAdmin, 'container': withInput, 'tab-pane active': clientAdmin}" id="tracking-content">
        <div class="tracking-content-inside" v-if="!searched && clientAdmin">   
            <textarea :placeholder="$helper.trans('Track_parcel_placeholder')" v-model="trackingNumberArea"></textarea>
            <button class="track_btn btn btn-yellow radius-4" @click="searchTrackings();">{{ $helper.trans('Track') }}</button>
            <img :src="routes['gif_url']" 
                alt="Loading" 
                class="d-block ml-auto mr-auto"
                style="height:20px; width:20px; margin-top:10px; margin-left:10px;"
                v-if="loading"
            > 
        </div> 
        <div class="row d-flex justify-content-center" v-else>
            <div class="col-12" v-if="withInput">
                <textarea class="w-100" :placeholder="$helper.trans('Track_parcel_placeholder')" rows="5" style="max-width: 815px;" v-model="trackingNumberArea"></textarea>
            </div>
            <div class="col-12">
                <button v-if="withInput" class="track_btn btn btn-yellow radius-4 mb-4" @click="searchTrackings();">{{ $helper.trans('Track') }}</button>
                <img :src="routes['gif_url']" 
                    alt="Loading" 
                    class="d-block ml-auto mr-auto"
                    style="height:20px; width:20px; margin-top:10px; margin-left:10px;"
                    v-if="loading"
                > 
            </div>
        </div>
        <div v-if="alert" class="alert alert-warning mt-5 alert_message" v-html="alertMessage"></div>
        <div class="d-block tracking_status_top toggle-wrap custom-tracking-summary-wrap" style="border: 0;">
            <tracking-number-component
                v-for="(tracking, trackingNumber) in trackingsObject" 
                :key="trackingNumber"
                :trackingNumber="trackingNumber"
                :statuses="statuses"
                :inclusiveStatuses="inclusiveStatuses"
                :tracking="tracking"
            ></tracking-number-component>
        </div>   
    </div>
</template>
<script>
export default {
    data: function () {
        return {
            routes: {},
            alert: false,
            alertMessage: '',
            loading: false,
            trackingNumbersArray: [],
            statuses: {
                waiting: ['Returned_to_Shipper', 'Not_Available', 'Billing_Information_Voided'],
                ready: ['Billing_Information_Received', 'Out_for_Delivery'],
                pickup: ['Warehousing', 'Delivered_Origin_CFS'],
                inTransit: ['Pickup', 'In_Transit', 'Exception'],
                delivered: ['Delivered', 'Delivered_Destination_CFS'],   
            },
            inclusiveStatuses: {},
            trackingsObject: {},
            trackingNumberArea: '',
            searched: false,
        }
    },
    props: {
        routesJson: {
            type: String,
            required: true,
        },
        trackingNumbers: {
            type: String,
            required: false,
            default: '',
        },
        withInput: {
            type: Boolean,
            required: false,
            default: false,
        },
        clientAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    created: function () {
        if(!this.withInput && !this.clientAdmin){
            this.loading = true;
        }

        this.inclusiveStatuses.delivered = structuredClone(this.statuses.delivered);
        this.inclusiveStatuses.inTransit = this.inclusiveStatuses.delivered.concat(this.statuses.inTransit);
        this.inclusiveStatuses.pickup = this.inclusiveStatuses.inTransit.concat(this.statuses.pickup);
        this.inclusiveStatuses.ready = this.inclusiveStatuses.pickup.concat(this.statuses.ready);
        this.inclusiveStatuses.waiting = this.inclusiveStatuses.ready.concat(this.statuses.waiting);

        this.routes = JSON.parse(Base64.decode(this.routesJson));
        
        this.trackingNumbersArray = this.trackingNumbers.split(/\n/).filter(function (trackingNumber) {
            return !empty(trackingNumber);
        });

        if(!this.withInput && !this.clientAdmin){
            this.getTrackingInfo();
        }
    },
    methods: {
        getTrackingInfo: function(){
            let vueThis = this;

            vueThis.trackingsObject = {};
            vueThis.openedParcels = [];
            vueThis.alert = false;
            vueThis.loading = true;

            let url = vueThis.routes['get_tracking_information_json'];
            let data = {
                trackingNumbers: vueThis.trackingNumbersArray,
            };
            axios.post(url, data)
            .then(function(response){
                if(Object.keys(response.data).length <= 0){
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'tracking_not_found',
                        'tracking_number': vueThis.trackingNumbersArray.join(', '),
                        'tracking_status': 'not_found'
                    });
                    vueThis.alertMessage = vueThis.$helper.trans('Parcel_not_found');
                    vueThis.alert = true;
                    return;
                }

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'tracking_found',
                    'tracking_number': vueThis.trackingNumbersArray.join(', '),
                    'tracking_status': 'found'
                });

                vueThis.trackingsObject = response.data;
            }).catch(function(errors){
                if(errors.response.status == 422){
                    let error_messages = '<ul class="mb-0">';   
                    $.each(errors.response.data.errors, function (className, error) { 
                        error_messages += `<li>${error}</li>`;
                    });   
                    
                    error_messages += '</ul>';
                    vueThis.alertMessage = error_messages;
                } else{
                    vueThis.alertMessage = vueThis.$helper.trans('Error_occurred');
                }
                vueThis.alert = true;
            }).finally(function(){
                vueThis.loading = false;
                vueThis.searched = true;
            });
        },
        searchTrackings: function(){
            this.loading = true;
            this.trackingNumbersArray = this.trackingNumberArea.split(/\n/).filter(function (trackingNumber) {
                return !empty(trackingNumber);
            });

            this.getTrackingInfo();
        },
    }
}
</script>
